import { Breadcrumb } from '@/components/Atoms/Breadcrumbs'
import Loading from '@/components/Atoms/Loading'
import { HasFeature } from '@/components/Atoms/Permissions'
import { Card, CardContent } from '@/components/ui/card'
import { PaymentsFeature } from '@/lib/features'
import { buildPath } from '@/routes'
import { Suspense } from 'react'
import { Navigate, Outlet } from 'react-router'

export function PaymentsLayout() {
  return (
    // Require the payments feature to be enabled
    <HasFeature
      feature={PaymentsFeature}
      noFeatureComponent={<Navigate to={buildPath('/')} />}
    >
      <Breadcrumb label="Payments" path={buildPath('/payments')} />
      <Card>
        <CardContent className="flex flex-col gap-4 lg:min-h-[300px]">
          <Suspense
            fallback={<Loading variant="fullscreen" className="min-h-64" />}
          >
            <Outlet />
          </Suspense>
        </CardContent>
      </Card>
    </HasFeature>
  )
}
